import { LegalPageLayout } from './LegalPageLayout';

export default function Impressum() {
  return (
    <LegalPageLayout title="Impressum" lastUpdated="Februar 2026" testId="impressum-page">
      <p className="italic text-slate-500">
        Hier wird das Impressum eingefügt. Die folgenden Angaben sind Platzhalter und müssen vor dem
        produktiven Einsatz durch den Betreiber mit den tatsächlichen, rechtsverbindlichen Daten ersetzt werden.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-3">Angaben gemäß § 5 TMG</h2>
      <p>
        [Name / Firma des Anbieters]<br />
        [Straße und Hausnummer]<br />
        [PLZ Ort]<br />
        Deutschland
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Vertreten durch</h2>
      <p>[Geschäftsführer / Vertretungsberechtigter Name]</p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Kontakt</h2>
      <p>
        Telefon: [Telefonnummer]<br />
        E-Mail: <a href="mailto:info@immo-verwaltung.online" className="text-violet-700 hover:underline">info@immo-verwaltung.online</a>
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Registereintrag</h2>
      <p>
        Eintragung im Handelsregister.<br />
        Registergericht: [Amtsgericht]<br />
        Registernummer: [HRB-Nummer]
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
        [DE000000000]
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        [Name]<br />
        [Anschrift]
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">Haftungsausschluss</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
        Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.
      </p>

      <p className="italic text-slate-400 text-xs mt-8">
        Hinweis: Dies ist ein automatisch generierter Platzhalter. Wir empfehlen, das Impressum vor Inbetriebnahme
        durch einen Anwalt oder einen Impressum-Generator (z.B. eRecht24, IT-Recht Kanzlei) prüfen zu lassen.
      </p>
    </LegalPageLayout>
  );
}
